import { defineStore } from 'pinia';
import { useGlobalStore } from '@/stores/GlobalStore';
import ajax from '@/utils/Ajax';

export const useRegisterStore = defineStore('register', {
  state: () => ({
    loading: false,
    step: '1-1', //
    hasCjAccount: false,
    is_back: false,
    cjProfileFormCache: null,
    inviteBrand: null, //紀錄邀請的brand，在termslist第一個顯示邀請的brand
    registerData: {
      //紀錄註冊的各種資料
      email: '',
      user_status: 0,
      avatar: null,
      name: '',
    },
    matchSocial: false,
    matchNum: Number(window.localStorage.getItem('CREATOR_PROTAL_match_count')) || 0, //只允許match 2次，match 2次要讓使用者重整才可再使用
    socialToken: {
      //連接出去的時候會產key存在這裡，頁免返回要根據有的key去做事，但有key做完事就要移除key(就算做失敗也要移除)
      google: JSON.parse(window.localStorage.getItem('CREATOR_PROTAL_google_social_key')) || null,
      tk: JSON.parse(window.localStorage.getItem('CREATOR_PROTAL_tk_social_key')) || null,
      ig: JSON.parse(window.localStorage.getItem('CREATOR_PROTAL_ig_social_key')) || null,
      yt: JSON.parse(window.localStorage.getItem('CREATOR_PROTAL_yt_social_key')) || null,
    },
    goSocialStep: false, //如果email submit按過後，email驗證沒過，開啟的下一步去驗證social"提示"(這時候都還是step1)
    isCjRegister: false, //cj註冊的
    verifityList: [
      {
        icon: 'instagram',
        name: 'Instagram',
        tag: 'ig',
        default_handle: '',
        backName: ['instagram', 'instagram_business','facebook_business'],
        show:true,
        social_platform: 'instagram',
      },
      {
        icon: 'tiktok-pure',
        name: 'TikTok',
        default_handle: '',
        tag: 'tk',
        backName: ['tikTok', 'tiktok_business'],
        show:true,
        social_platform: 'tikTok',
      },
      // {
      //   icon: 'youTube',
      //   name: 'YouTube',
      //   default_handle: '',
      //   tag: 'yt',
      //   backName: ['youTube', 'youtube', 'youtube_business'],
      //   show: true,
      //   social_platform: 'youtube',
      // },
    ], //紀錄需驗證social
    spHandle: [],
    brand_id: null, //紀錄選擇的brand id
  }),

  getters: {
    // Define your getters here
    // https://pinia.vuejs.org/core-concepts/getters.html
  },

  actions: {
    // 從 LoginPage 呼叫時 res 帶 access_token，會自動 setToken + navigate
    // 從 RegisterPage 呼叫時 res 只有 user_status，只做 step 切換
    async matchEmail(res) {
      const isFromLogin = !!res.access_token;

      if (isFromLogin) {
        const GlobalStore = useGlobalStore();
        GlobalStore.setToken(res.access_token);
        this.registerData.user_status = res.user_status;
      }

      console.log('matchEMAIL:res.user_status', res.user_status);

      if (res.user_status === 5) {
        return false;
      }
 
      if (res.user_status === 100) {
        window.location.href = '/';
        return true;
      }

      this.hasCjAccount = res.is_has_cj_account === 1;
      window.localStorage.setItem('CREATOR_PROTAL_hasCjAccount', this.hasCjAccount);
      this.step = '1';

      if (isFromLogin) {
        window.localStorage.setItem(`is_cj_go_step${this.step}`, true);
        window.location.href = '/register';
      }
      return true;
    },

    clearUserHandle(tag) {
      switch (tag) {
        case 'google':
          this.socialToken.google = null;
          break;
        case 'tk':
          this.socialToken.tk = null;
          break;
        case 'ig':
          this.socialToken.ig = null;
          break;
      }
      window.localStorage.removeItem(`CREATOR_PROTAL_${tag}_social_key`);
    },

    async handleRegisterUpdatePassword() {
      await this.handleRegisterSocial();
      this.step = '3-1';
    },

    async spGetUserHandle() {
      this.loading = true;
      try {
        const res = await ajax.get('/get-user-handle-list');
        const data = res.data.data;
        data.sort((a, b) => {
          const aHasIG = a.social_platform.includes('instagram') ? 1 : 0;
          const bHasIG = b.social_platform.includes('instagram') ? 1 : 0;
          return bHasIG - aHasIG;
        });
        this.spHandle = data;
      } catch (err) {
        console.log(err);
        // this.spHandle = [
        //   { handle: 'fake_ig_user', social_platform: 'instagram', from: 'instagram' },
        //   { handle: 'fake_tk_user', social_platform: 'tikTok', from: 'tikTok' },
        //   { handle: 'fake_yt_user', social_platform: 'youtube', from: 'youtube' },
        // ];
      } finally {
        this.loading = false;
      }
    },

    async handleRegisterSocial() {
      this.loading = true;
      try {
        const res = await ajax.get('/get-user-default-handle');
        const data = res.data.data;
        this.verifityList.forEach((platform) => {
          for (const key of platform.backName) {
            if (data[key] && data[key].handle) {
              platform.default_handle = data[key].handle;
              platform.connect_status=  data[key].connect_status;
              platform.handle = data[key].handle;
              break; // 找到就停止，不再繼續檢查 backName 中其他名稱
            }
          }
        });
      } catch (err) {
        console.error('Error fetching user handle list:', err);
      } finally {
        this.loading = false;
      }
    },

    async handleVerSocialPage() {
      await this.spGetUserHandle();
      if (this.spHandle.length > 0) {
        this.step = '3-2'; // has handles, go to choose handle
      } else {
        await this.handleRegisterSocial();
        this.step = '3-1'; // no handles, go to verify social
      }
    }
  },
});
